import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { AnalysisPaceDTO } from "./types";

const MS_URL = "senana/farm/analysis";
const responseParser = responseContent(AnalysisPaceDTO);


export const getByUuid = async (uuid: string, crop_type: string): Promise<ResponseContent<AnalysisPaceDTO>> => axios
  .get(`${MS_URL}/${uuid}/pace`, { params: { crop_type }})
  .then(responseParser)
